import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Reports from "../Reports";
import ModeofpaymentList from "../ModeofpaymentList";

function AdminModeOfPayment(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={6}
        childrenPage={<ModeofpaymentList/>}/>
        </DataContext.Provider>
    )
}

export default AdminModeOfPayment;